import React from "react";
import { Button } from "antd";
import { QUICK_FILTERS, isQuickFilterActive } from "../utils/quickFilterUtils";

const QuickFilterButtons = ({ filters, onToggle }) => (
  <>
    {QUICK_FILTERS.map(({ key, label, color, kind }) => {
      const active = isQuickFilterActive(filters, key, kind);

      return (
        <Button
          key={key}
          onClick={() => onToggle(key, kind)}
          style={{
            borderColor: color,
            color: active ? "#fff" : color,
            backgroundColor: active ? color : "transparent",
            fontWeight: 500,
          }}
        >
          {label}
        </Button>
      );
    })}
  </>
);

export default QuickFilterButtons;
